<template>
  <div class="box heatmap-stats py-4 scrollable">
    <div id="edit-form">
      <div class="col-md-12 px-4 mx-auto">
        <div class="row">
          <div class="col-md-12 col-xs-12 mx-auto">
            <div class="row">
              <div class="col">
                <h5>Page stats - {{ device | capitalize }}</h5>
              </div>
              <div class="col text-right">
                <!-- <button class="btn btn-muted" @click="downloadPdf()">
                  <font-awesome-icon icon="save" />
                </button> -->
                <button class="btn btn-muted" @click="exportCsv()">
                  <font-awesome-icon icon="save" />
                </button>
              </div>
            </div>

            <ul class="list-group mt-3">
              <li class="list-group-item">
                Visitors
                <span class="float-right">{{ stats.visitors || 0 }}</span>
              </li>
              <li class="list-group-item">
                Engaged Visitors
                <span class="float-right"
                  >{{
                    ((stats.engagedvisitors / stats.visitors) * 100).toFixed(
                      2
                    ) || 0
                  }}%</span
                >
              </li>
              <li class="list-group-item">
                Clicks
                <span class="float-right">{{ stats.clicks || 0 }}</span>
              </li>
              <li class="list-group-item">
                Clicks/Visits
                <span class="float-right">{{
                  (stats.clicks / stats.visitors || 0).toFixed(2)
                }}</span>
              </li>
            </ul>
            <ul class="list-group mt-3">
              <template v-for="(value, name) in data">
                <li
                  v-if="
                    value.nodename.toLowerCase() !== 'body' &&
                    value.nodename.toLowerCase() !== 'section'
                  "
                  class="list-group-item"
                  :key="name"
                >
                  <div class="mb-3">
                    <div class="content-header">
                      <b>{{
                      el_dictionary[value.nodename] ||
                      value.nodename | capitalize
                    }}</b>
                    <button v-if="value.text.trim().length > 54 && showMore !== name" style="margin-left: 240px;" class="show-btn" @click="toggleShowMore(name)">Show More</button>
                    <button v-else-if="value.text.length > 54 && showMore === name" style="margin-left: 280px;" class="show-btn" @click="toggleShowMore(name)">Hide</button>
                    </div>
                    <span 
                      :class="showMore === name ? 'list-group-content-expand':'list-group-content'"
                      v-if="value.src === '' && value.nodename !== 'svg'"
                      v-html="value.text || name"
                    >
                    </span>
                    <div
                      style="max-width: 100px"
                      v-else-if="value.nodename === 'svg'"
                      v-html="value.html"
                    ></div>
                    <img class="img-fluid" v-else :src="value.src" />
                  </div>
                  <span class="text-muted">
                    <font-awesome-icon icon="mouse-pointer" class="fa fa-sm" />
                    {{ value.count }}
                    <span class="float-right"
                      >{{
                        ((value.count / stats.clicks) * 100).toFixed(2)
                      }}%</span
                    >
                    <div
                      class="mt-1 progress progress-mini clearfix"
                      style="height: 5px !important"
                    >
                      <div
                        role="progressbar"
                        class="progress-bar"
                        :style="
                          'width: ' +
                          ((value.count / maxCount) * 100).toFixed(2) +
                          '% !important;'
                        "
                        v-bind:aria-valuenow="
                          ((value.count / maxCount) * 100).toFixed(2)
                        "
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </span>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'

export default {
  props: ['stats', 'device'],
  data: function () {
    return {
      maxCount: 0,
      data: [],
      el_dictionary: {
        div: 'Container',
        a: 'hyperlink',
        h1: 'heading 1',
        h2: 'heading 2',
        h3: 'heading 3',
        h4: 'heading 4',
        h5: 'heading 5',
        h6: 'heading 6',
        li: 'list item',
        ul: 'list container',
        ol: 'list container',
        img: 'image',
        dl: 'definition list',
        dt: 'definition term',
        dd: 'definition description',
        em: 'emphasis text',
        i: 'italic text',
        strong: 'strong text',
        b: 'bold text',
        u: 'underlined text',
        s: 'strikethrough text',
        mark: 'marked text',
        hgroup: 'heading group',
        figcaption: 'figure caption',
        p: 'paragraph',
        tr: 'table row',
        td: 'table cell',
        th: 'table heading',
        thead: 'table header',
        tbody: 'table body',
        tfoot: 'table foot',
        col: 'table column',
        colgroup: 'table column group',
        abbr: 'abbreviation',
        bdo: 'bidirection override',
        br: 'line break',
        hr: 'horizontal rule',
        caption: 'table caption',
        del: 'deleted text',
        ins: 'inserted text',
        dfn: 'instance definition',
        q: 'inline quote',
        strike: 'strikethrough text',
        sub: 'subscript',
        sup: 'superscript',
        tt: 'teletype',
        nav: 'navigation block',
        pre: 'preformatted block',
        kbd: 'keyboard input',
        ruby: 'ruby annotation',
        rt: 'ruby text',
        rp: 'ruby parentheses',
        bdi: 'inline bidirectional override',
        wbr: 'line break opportunity',
      },
      showMore: ""
    }
  },
  store,
  methods: {
    // downloadPdf() {
    //   if (
    //     this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
    //     this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
    //   ) {
    //     this.$swal.fire({
    //       title: 'Premium Feature',
    //       text: 'You will need to upgrade you account to any of our paid plan to download heatmap stats.',
    //       type: 'warning',
    //       confirmButtonColor: '#2167f5',
    //     })
    //     return
    //   }
    //   var jsPDF = require('jspdf')
    //   var html2canvas = require('html2canvas')

    //   let imgs = document.getElementsByTagName('img')

    //   for (let i = 0; i < imgs.length; i++) {
    //     imgs[i].src = imgs[i].src + '?v=' + new Date().getTime()
    //     imgs[i].setAttribute('crossOrigin', true)
    //   }

    //   var listing = document.getElementsByClassName('listing')
    //   var btn = document.getElementsByClassName('listing')
    //   var scrollable = document.getElementsByClassName('scrollable')

    //   for (let i = 0; i < listing.length; i++) {
    //     listing[i].classList.add('noshadow')
    //   }

    //   for (let i = 0; i < btn.length; i++) {
    //     btn[i].classList.add('noshadow')
    //   }

    //   for (let i = 0; i < scrollable.length; i++) {
    //     scrollable[i].classList.remove('scrollable')
    //   }
    //   var offScreen = document.getElementsByClassName('heatmap-stats')[0]

    //   html2canvas(offScreen, {
    //     logging: true,
    //     letterRendering: 1,
    //     allowTaint: false,
    //     useCORS: true,
    //     scale: 1,
    //     // onrendered: function (canvas) {
    //     //   document.body.appendChild(canvas)
    //     //   document.body.removeChild(clone)
    //     // },
    //   }).then(function (canvas) {
    //     var imgData = canvas.toDataURL('image/png')
    //     var imgWidth = 210
    //     var pageHeight = 295
    //     var imgHeight = (canvas.height * imgWidth) / canvas.width
    //     var heightLeft = imgHeight
    //     var doc = new jsPDF('p', 'mm')
    //     var position = 10 // give some top padding to first page

    //     doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    //     heightLeft -= pageHeight

    //     while (heightLeft >= 0) {
    //       position = heightLeft - imgHeight // top padding for other pages
    //       doc.addPage()
    //       doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    //       heightLeft -= pageHeight
    //     }
    //     doc.save('heatmap_stats.pdf')

    //     for (let i = 0; i < listing.length; i++) {
    //       listing[i].classList.remove('noshadow')
    //     }

    //     for (let i = 0; i < btn.length; i++) {
    //       btn[i].classList.remove('noshadow')
    //     }

    //     for (let i = 0; i < scrollable.length; i++) {
    //       scrollable[i].classList.add('scrollable')
    //     }
    //   })
    // },
    exportCsv() {
      if (
        this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
        this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
      ) {
        this.$swal.fire({
          title: 'Premium Feature',
          text: 'You will need to upgrade you account to any of our paid plan to download polls data.',
          type: 'warning',
          confirmButtonColor: '#2167f5',
        })
        return
      }
      function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
      var heatmap_stats1 = []
      var heatmap_stats2 = []
      let data1 = []
      let data2 = []
      let data3 = []
      let data4 = []
      let data5 = []

      heatmap_stats1.push(
        [
          '"Visitors"',
          '"Engaged_visitors"',
          '"Clicks(%)"',
          '"Clicks/Visits"',
        ].join(';')
      )
      heatmap_stats2.push(
        ['"Node_name"', '"count"', '"Clicks_stats(%)"', '"Text"'].join(';')
      )

      data1.push('"' + this.stats.visitors || 0 + '"')
      data1.push(
        '"' +
          (((this.stats.engagedvisitors / this.stats.visitors) * 100).toFixed(
            2
          ) || 0) +
          '"'
      )
      data1.push('"' + this.stats.clicks || 0 + '"')
      data1.push(
        '"' + (this.stats.clicks / this.stats.visitors || 0).toFixed(2) + '"'
      )
      heatmap_stats1.push(data1.join(';'))

      for (let i = 0; i < this.data.length; i++) {
        data2.push(
          '"' +
            capitalizeFirstLetter(
              this.el_dictionary[this.data[i].nodename] || this.data[i].nodename
            ) +
            '"'
        )
        data3.push('"' + this.data[i].count + '"')
        data4.push(
          '"' +
            ((this.data[i].count / this.stats.clicks) * 100).toFixed(2) +
            '"'
        )

        if (this.data[i].src === '') this.data[i].text
        else this.data[i].text = this.data[i].src
        if (this.data[i].text === '') {
          this.data[i].text = i
        }

        data5.push('"' + this.data[i].text + '"')
      }

      let array = [data2, data3, data4, data5]
      let heatmap_list = []
      array = array.sort(function (a, b) {
        return b.length - a.length
      })

      for (let i = 0; i < array[0].length; i++) {
        heatmap_list[i] = array[0][i]
      }
      heatmap_list = heatmap_list.map((e, i) => {
        return (e + ';' + array[1][i]).replace('undefined', '__')
      })
      heatmap_list = heatmap_list.map((e, i) => {
        return (e + ';' + array[2][i]).replace('undefined', '__')
      })
      heatmap_list = heatmap_list.map((e, i) => {
        return (e + ';' + array[3][i]).replace(/\s+/g, ' ')
      })

      for (let i = 0; i < heatmap_list.length; i++) {
        heatmap_stats2.push(heatmap_list[i])
      }
      console.log(heatmap_list)
      var stats1_string = heatmap_stats1.join('\n')
      var filename =
        'heatmap stats 1_' + new Date().toLocaleDateString() + '.csv'
      var link = document.createElement('a')
      link.style.display = 'none'
      link.setAttribute('target', '_blank')
      link.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' + encodeURIComponent(stats1_string)
      )
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      var stats2_string = heatmap_stats2.join('\n')
      var filename =
        'heatmap stats 2_' + new Date().toLocaleDateString() + '.csv'
      var link = document.createElement('a')
      link.style.display = 'none'
      link.setAttribute('target', '_blank')
      link.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' + encodeURIComponent(stats2_string)
      )
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    toggleShowMore (data) {
      if(this.showMore === data) {
        this.showMore = ""
      }else {
        this.showMore = data
      }
    }
  },
  beforeMount() {},
  mounted() {
    setTimeout(() => {
      let keys = Object.keys(this.stats.pathData)
      keys.forEach((key) => {
        this.data.push(this.stats.pathData[key])
      })

      this.data.sort(function (a, b) {
        return b.count - a.count
      })
      this.maxCount = this.data[0].count
    }, 100)
  },
}
</script>
<style>
 .list-group-content {
  word-wrap: break-word;
  height: 21px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
 }

 .list-group-content-expand {
  word-wrap: break-word;
 }

 .content-header {
  margin-bottom: 14px;
  position: relative;
 }

 .show-btn {
  margin-bottom: 1rem;
  font-weight: 500;
  background: none;
  border: none;
  font-size: 14px;
  margin-left: 0;
  padding-left: 0;
  text-decoration: underline;
  color: #7276f5;
  transition: all ease-in 100ms !important;
  outline: none;
  padding-right: 0;
  position: absolute;
  right: 0;
 }

 .show-btn:focus {
  outline: none;
  color: #7276f5;
 }

 .show-btn:hover {
  cursor: pointer;
  color: #6267f5;
 }
</style>



// WEBPACK FOOTER //
// src/components/HeatmapStats.vue